import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Button,
  CardMedia,
  IconButton,
  Input,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as Yup from "yup";
import { showError, showToast } from "../../constants/toasts";
import {
  useAddSubscriptionMutation,
  useLazyGetSubscriptionDetailsQuery,
  useUpdateSubscriptionMutation,
} from "../../service/subscription";
import Loader from "../../constants/Loader";

function AddSubscription() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [subscriptionDetails] = useLazyGetSubscriptionDetailsQuery();
  const [updateSubscription] = useUpdateSubscriptionMutation();
  const [addSubscription] = useAddSubscriptionMutation();
  const [image, setImage] = useState<any>("");
  const [url, setUrl] = useState("");
  const [error, setError] = useState(false);
  const [details, setDetails] = useState<any>();
  const [loading, setLoading] = useState(false);

  const goBack = () => {
    navigate(-1); // this goes one step back in history
  };

  const handleChangeSubscription = (event: SelectChangeEvent) => {
    const { value } = event.target;
    formik.setFieldValue("subscriptionFor", value);
  };

  const handleChangeType = (event: SelectChangeEvent) => {
    const { value } = event.target;
    formik.setFieldValue("type", value);
  };

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setImage("");
      return;
    }

    setImage(file);
    setUrl(URL.createObjectURL(file));
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      subscriptionFor: details?.memberShipType || "",
      type: details?.memberShipPlan || "",
      price: details?.price || "",
      description: details?.description || "",
    },
    validationSchema: Yup.object({
      price: Yup.string().required().required("Price is required"),
      description: Yup.string().required().required("Description is required"),
    }),

    onSubmit: async (values) => {
      formik.setSubmitting(true);

      // if (!image) {
      //   showError("Please upload image");
      //   return;
      // }

      const formData = new FormData();

      formData.append("subscriptionFor", values.subscriptionFor);
      formData.append("SubscriptionType", values.type);
      formData.append("Price", values.price);
      formData.append("Description", values.description);
      formData.append("Image", image);
      if (id) {
        formData.append("id", id);
      }

      if (id) {
        try {
          setLoading(true);
          const response = await updateSubscription(formData).unwrap();
          setLoading(false);
          if (response?.status === 200) {
            goBack();
            showToast(response?.message || "");
          } else {
            showError(response?.message || "");
          }
        } catch (error: any) {
          setLoading(false);
          showError(error?.data?.message || "");
          console.error(error);
        }
      } else {
        try {
          setLoading(true);
          const response = await addSubscription(formData).unwrap();
          setLoading(false);
          if (response?.status === 200) {
            goBack();
            showToast(response?.message || "");
          } else {
            showError(response?.message || "");
          }
        } catch (error: any) {
          setLoading(false);
          showError(error?.data?.message || "");
          console.error(error);
        }
      }
    },
  });

  const subscriptionDetailsApi = async () => {
    try {
      const response = await subscriptionDetails({
        id,
      }).unwrap();
      if (response.status === 200) {
        setDetails(response?.data?.subscriptionDetails);
      } else {
        showError(response?.message);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (id) {
      subscriptionDetailsApi();
    }
  }, []);

  return (
    <>
      <MainContainer>
        <Loader isLoad={loading} />
        <div className="main_title d_flex">
          <div className="left_s">
            <h1 className="back_arrow">
              {" "}
              <IconButton onClick={() => goBack()}>
                {" "}
                <ArrowBackIcon />{" "}
              </IconButton>{" "}
              Add Subscription
            </h1>
          </div>

          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => {
                setError(true);
                formik.submitForm();
              }}
            >
              Save
            </Button>
          </div>
        </div>

        <div className="cards">
          <form>
            <div className="gap_m">
              <div className="control_group w_100">
                <label>Upload Image</label>
                {url ? (
                  <div className="upload_image">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia component="img" image={url} alt="photo" />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setImage("");
                          setUrl("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label className="upload_image" htmlFor="icon-button-file">
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                      }}
                      onChange={(e: any) => {
                        handleImageUpload(e);
                        e.target.value = null;
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img src="/static/images/placeholder.png" alt="icon" />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="icon" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>

              <div className="control_group w_33">
                <label htmlFor="demo-simple-select">Subscription For</label>
                <Select
                  className="dropse"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  value={formik.values.subscriptionFor}
                  name="single"
                  onChange={handleChangeSubscription}
                >
                  <MenuItem value="" disabled>
                    Select
                  </MenuItem>

                  <MenuItem value="Single">Single</MenuItem>
                  <MenuItem value="Duo">Duo</MenuItem>
                </Select>
                {error && !formik.values.subscriptionFor ? (
                  <h6 className="err_msg">Subscription For is required</h6>
                ) : null}
              </div>

              <div className="control_group w_33">
                <label htmlFor="demo-simple-select">Type</label>
                <Select
                  className="dropse"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  value={formik.values.type}
                  name="gender"
                  onChange={handleChangeType}
                >
                  <MenuItem value="" disabled>
                    Select subscription type
                  </MenuItem>

                  <MenuItem value="Monthly">Monthly </MenuItem>
                  <MenuItem value="Quarterly">Quarterly</MenuItem>
                  <MenuItem value="Annually">Annually</MenuItem>
                  <MenuItem value="SemiAnnually">Semi Annually</MenuItem>

                  {/* <MenuItem value="Semiannually">Semiannually </MenuItem>
                  <MenuItem value="Yearly">Yearly </MenuItem> */}
                </Select>
                {error && !formik.values.type ? (
                  <h6 className="err_msg">Subscription type For is required</h6>
                ) : null}
              </div>
              <div className="control_group w_33">
                <label htmlFor="price">Price</label>
                <TextField
                  placeholder="Enter Price"
                  hiddenLabel
                  fullWidth
                  value={formik.values.price}
                  id="price"
                  name="price"
                  className="text_field"
                  inputProps={{ maxLength: 10 }}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits and optional one dot for decimal
                    if (/^\d*\.?\d*$/.test(value)) {
                      formik.setFieldValue("price", value);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.price &&
                    typeof formik.errors.price === "string"
                      ? formik.errors.price
                      : ""
                  }
                />
              </div>

              <div className="control_group w_100">
                <label htmlFor="description">Description</label>
                <TextField
                  placeholder="Enter description"
                  hiddenLabel
                  fullWidth
                  multiline={true}
                  value={formik.values.description}
                  minRows={5}
                  id="description"
                  name="description"
                  className="text_field"
                  inputProps={{ maxLength: 250 }}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.description &&
                    typeof formik.errors.description === "string"
                      ? formik.errors.description
                      : ""
                  }
                />
              </div>
            </div>
          </form>
        </div>
      </MainContainer>
    </>
  );
}

export default AddSubscription;
